import { render, staticRenderFns } from "./BoardColumn.vue?vue&type=template&id=6d412813&"
import script from "./BoardColumn.vue?vue&type=script&lang=ts&"
export * from "./BoardColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports